export default "__VITE_ASSET__CzibG0wR__"